// extracted by mini-css-extract-plugin
export default {"stats":"github_stats__JpvMS"};